import React from 'react';
import BlockContent from '@sanity/block-content-to-react';
import { Link } from 'gatsby';
import Seo from '../components/Seo';

export default ({
	pageContext,
	location,
}) => {
	const {seo = {}} = pageContext;
	
	const metaTitle = seo.metaTitle || `${pageContext.title} | Teddy Baldassarre`;
	const openGraphTitle = seo.openGraphTitle || `${pageContext.title} | Teddy Baldassarre`;
	const twitterTitle = seo.twitterTitle || `${pageContext.title} | Teddy Baldassarre`;

	return (
		<React.Fragment>
			<Seo
				metaTitle={metaTitle}
				metaDescription={seo.metaDescription}
				metaKeywords={seo.metaKeywords}
				openGraphTitle={openGraphTitle}
				openGraphDescription={seo.openGraphDescription}
				openGraphImage={seo.openGraphImage}
				twitterTitle={twitterTitle}
				twitterDescription={seo.twitterDescription}
				twitterImage={seo.twitterImage}
				pathname={location.pathname}
			/>
			<div className="bg--gray-bg bb--gray-border pt6 pb6 pt10--md pb10--md">
				<div className="grid-container contained">
					<div className="row align--center">
						<div className="col c8--md">
							<p className="tc mb3">
								<Link
									className="button--back"
									to="/">
									Back to Watches
								</Link>
							</p>
							<h1 className="tc domaine--large">{pageContext.title}</h1>
						</div>
					</div>
				</div>
			</div>
			<div className="grid-container contained pt6 pb6 pt10--md pb10--md">
				<div className="row align--center">
					<div className="col c8--md">
						<div className="rich-text rich-text--page">
							<BlockContent blocks={pageContext.body} />
						</div>
					</div>
				</div>
			</div>
		</React.Fragment>
	);
};